import axiosClient from "utils/axios";
import { ApiList, ApiResponse } from "types/api.types";
import { Settlement } from "features/EmployeeAdvanceSettlements/types/employee-advance-settlement.types";
import type { EmployeeAdvanceSettlementSourceType } from "features/EmployeeAdvanceSettlements/constants/employee-advance-settlement.constants";

export const getEmployeeAdvanceSettlements = async ({
  page,
  limit,
  search,
  employeeAdvanceId,
  sourceType,
  sourceId,
}: {
  page?: number;
  limit?: number;
  search?: string;
  employeeAdvanceId?: number;
  /** PAYROLL or MANUAL — invalid values are silently ignored by the API. */
  sourceType?: EmployeeAdvanceSettlementSourceType | string;
  sourceId?: number;
} = {}) => {
  try {
    const response = await axiosClient.get<ApiResponse<ApiList<Settlement[]>>>(
      "/employee-advance-settlements",
      { params: { page, limit, search, employeeAdvanceId, sourceType, sourceId } },
    );
    return response.data;
  } catch (err) {
    console.warn("Error fetching Employee Advance Settlement list : ", err);
    throw err;
  }
};

export const getEmployeeAdvanceSettlement = async (id: number) => {
  try {
    if (!Number.isInteger(id) || id <= 0) {
      throw new Error("Invalid ID");
    }
    const response = await axiosClient.get<ApiResponse<Settlement>>(
      `/employee-advance-settlements/${id}`,
    );
    return response.data;
  } catch (err) {
    console.warn("Error fetching Employee Advance Settlement details : ", err);
    throw err;
  }
};
